import store from '@/store';
import router from '@/router';
export default {
  created() {
    // タブに画面名を表示する設定
    let { title } = this.$options;
    if (title) {
      title = typeof title === 'function' ? title.call(this) : title;
      document.title = `Kobelink ${title}`;
    }
  },
  methods: {
    async apiRequest(url, method, params, snackbar = true) {
      // 本番環境のみアクセストークンが古い場合トークンの再取得を行う
      if (process.env.NODE_ENV === 'production' && this.$msal.data.accessToken !== store.getters['auth/access_token']) {
        console.log('トークン再取得');
        await store.dispatch('auth/get_access_token', { msal: this.$msal });
      }
      url = 'https://www2.kobelink.com' + url;
      const accessToken = store.getters['auth/access_token'];
      const headers = { Authorization: `Bearer ${accessToken}` };
      let func = undefined;
      if (method === 'PUT') {
        func = async () => {
          return await this.axios.put(url, params, { headers: headers });
        };
      } else if (method === 'GET') {
        func = async () => {
          return await this.axios.get(url, {
            params: params,
            headers: headers,
          });
        };
      } else if (method === 'POST') {
        func = async () => {
          return await this.axios.post(url, params, { headers: headers });
        };
      } else {
        func = async () => {
          return await this.axios.delete(url, { headers: headers });
        };
      }
      const data = await func()
        .then((res) => {
          console.log(res);
          if (url.endsWith('/v1/alarm-event-mgt/eventHistory')) {
            // eventHistoryだけ常にdataのlengthが0になるので特例
            return res.data.event_history_list.length > 0 ? res.data.event_history_list : null;
          }
          return res.data.length > 0 ? res.data : null;
        })
        .catch((err) => {
          console.log(err.response.data);
          if (err.response && err.response.status === 401) {
            if (process.env.NODE_ENV !== 'production') {
              store.commit('auth/clear_state');
              store.commit('groupAuthorities/clear_state');
              localStorage.removeItem('vuex');
              router.push('/Login');
              store.commit('loading/end_loading');
            }
          }
          if (snackbar) {
            store.commit('snackbar/show_snackbar', {
              text: err.response.data ?? err,
              color: 'error',
              timeout: 5000,
              multiline: false,
            });
          }
          return null;
        });
      return data;
    },
    async azureRequest(url, method, params, snackbar = true) {
      if (!url.startsWith('https')) {
        url = `${process.env.VUE_APP_AZURE_FUNCTIONS_URI}${url}`;
      }
      // アプリキーの _default
      const headers = {
        'x-functions-key': process.env.VUE_APP_AZURE_X_FUNCTIONS_KEY,
      };
      let func = undefined;
      if (method === 'POST') {
        func = async () => {
          return await this.axios.post(url, params, { headers: headers });
        };
      } else if (method === 'PUT') {
        func = async () => {
          return await this.axios.put(url, params, { headers: headers });
        };
      } else if (method === 'DELETE') {
        func = async () => {
          return await this.axios.delete(url, {
            data: params,
            headers: headers,
          });
        };
      } else if (method === 'GET_BLOB') {
        func = async () => {
          return await this.axios.get(url, {
            params: params,
            headers: headers,
            responseType: 'blob',
          });
        };
      } else {
        func = async () => {
          return await this.axios.get(url, {
            params: params,
            headers: headers,
          });
        };
      }
      const data = await func()
        .then((res) => {
          console.log(res);
          return res.data;
        })
        .catch((err) => {
          console.log(err.response);
          if (snackbar) {
            store.commit('snackbar/show_snackbar', {
              text: err,
              color: 'error',
              timeout: 5000,
              multiline: false,
            });
          }
          return null;
        });
      return data;
    },
  },
};
